<!-- =========================================================================================
  File Name: QnAList.vue
  Description: QnA List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">

</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Agenda Builder</h3>
      <div class="knowlg-base-wrap-sec hidden">
        <a href="/pages/knowledge-base/category-sessions/question-2"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></span> Need help with this section?</a>
      </div>
    </div>    
    

    <div class="vx-card p-6">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-5">
         <div class="angeda-builder-left">
            <vs-input
            class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="searchQuery"
            @input="updateSearchQuery"
            placeholder="Group Name"
            />  
            <vs-button type="filled" class="mr-3 border" @click="addMapping" color="rgb(76, 139, 246)">Add/Edit Mappings</vs-button>          
          </div>
        </div>
        <div class="vx-col md:w-1/1 w-full">
          <vs-tabs  alignment="left" v-model="selectedTab" >
            <vs-tab label="Mapping by Session" @click="getListData('Session')"></vs-tab>
            <vs-tab label="Mapping by User" @click="getListData('User')"></vs-tab>
            <vs-tab label="Mapping by Group" @click="getListData('Group')"></vs-tab>
          </vs-tabs>
        </div>
        <div class="vx-col md:w-1/2 w-full">
        </div>
        <div class="vx-col md:w-1/2 w-full mb-5">
          <div class="mapping-add-button">         
            
          </div>
          <vs-popup class="holamundo mapping-popup-wrapper" title="Add/Edit Mapping" :active.sync="popupActive">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full border-right-1">
                <div class="attendee-map-head mb-4">
                  <h4 >Groups</h4>
                  <div class="map-switch" v-if="!SessionEdit">
                    <label class="mr-3">Select all</label>
                    <vs-switch @change="selectAllGroups" v-model="SelectAllGroups" />
                  </div>
                </div>
                <div class="search-section mt-3">
                   <vs-input v-if="!SessionEdit" class="inputx w-full" @click.stop="show2" placeholder="Search Groups" @keyup="searchGroup" v-model="groupName" />
                   <div class="callout attendee-search-section" v-if="showInside2" >
                    <div class="attendee-search-top">
                      <vs-checkbox @change="selectAllGroups" v-model="SelectAllGroups">Select all</vs-checkbox>
                      <div class="drop-area-top-right">
                        <vs-button color="primary" type="filled" class="mr-3" @click="hide">Add</vs-button>
                        <a href="javascript:void(0)" @click="hide">x</a>
                      </div>
                    </div>
                    <div class="attendee-list">
                      <ul>
                        <li v-for="group in group_search_list">
                          <vs-checkbox v-model="SelectedGroups" :vs-value="group">{{group.GroupName}}
                          </vs-checkbox>
                        </li>                        
                      </ul>
                    </div>
                   </div>
                </div>
                <div class="attendee-mapping mt-3">
                  <div class="mapped-attendee-wrapper">
                    <div class="mapped-attendee" v-for="group in SelectedGroups">
                      <vs-checkbox v-model="SelectedGroupsOuter" :vs-value="group">{{group.GroupName}}</vs-checkbox> 
                      <!--<a href="javascript:void(0)" class="close-ico2" @click="removeAttendee(attendee)">x</a>-->
                    </div>                    
                  </div>
                  <div class="mapping-drop-area-bottom">
                    <!-- <div class="removal-allow">
                      <label class="mr-3">Allow Removal</label>
                      <vs-switch v-model="switch5" />
                    </div> -->
                    <div class="selected-action">
                     <!--  <a href="javascript:void(0)" class="mr-5 delete-button" @click="deleteAllSelectedGroups">x Delete Selected</a>
                      <a href="javascript:void(0)" class="select-all-button" @click="selectAllSelectedGroups"><span></span> Select All</a> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <h4 class="mb-4">Session</h4>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <datepicker placeholder="Select Date" :clear-button="true" v-model="StartDate"></datepicker>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <v-select placeholder="Select Track" v-model="Track" label="TrackName" :options="trackList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </div>
                </div>
                <div class="search-section mt-3">
                   <vs-input class="inputx w-full" @click.stop="show" placeholder="Search Session" v-model="sessionName" @keyup="searchSession" />
                   <div class="callout session-search-drop" v-if="showInside" >
                      <div class="drop-area-top">
                        <vs-checkbox @change="selectAllSessions" v-model="SelectAllSessions">Select all</vs-checkbox>
                        <div class="drop-area-top-right">
                          <vs-button color="primary" type="filled" class="mr-3" @click="hide">Add</vs-button>
                          <a href="javascript:void(0)" @click="hide">x</a>
                        </div>
                      </div>
                      <div class="session-listing">
                        <div class="single-list-session mb-5" v-for="session in session_search_list">
                          <vs-checkbox v-model="SelectedSessions" :vs-value="session"></vs-checkbox>
                          <div class="single-session-details">
                            <h5>{{session.Name}}</h5>
                            <p>
                              {{SetTimeByZoneinList(new Date(session.StartDate.seconds * 1000).toUTCString())}} ,
                              {{SetTimeByZoneinList(new Date(session.EndDate.seconds * 1000).toUTCString())}} 
                            </p>
                          </div>
                        </div>                        
                      </div>
                   </div>
                </div>
                <div class="mapping-drop-area mt-3">
                  <div class="selected-session-wrap">
                    <div class="selected-session" v-for="session in SelectedSessions">
                      <vs-checkbox v-model="SelectedSessionsOuter" :vs-value="session"></vs-checkbox>
                      <div class="selected-session-details">
                        <h5>{{session.Name}}</h5>
                        <p>
                          {{SetTimeByZoneinList(new Date(session.StartDate.seconds * 1000).toUTCString())}} ,
                          {{SetTimeByZoneinList(new Date(session.EndDate.seconds * 1000).toUTCString())}} 
                        </p>
                      </div>
                      <!-- <div class="close-ico" @click="removeSession(session)">x</div> -->
                    </div>                    
                  </div>
                  <div class="mapping-drop-area-bottom">
                    <!-- <div class="removal-allow">
                      <label class="mr-3">Allow Removal</label>
                      <vs-switch v-model="switch5" />
                    </div> -->
                    <div class="selected-action">
                      <a href="javascript:void(0)" @click="deleteAllSelectedSessions" class="mr-5 delete-button">x Delete Selected</a>
                      <a href="javascript:void(0)" @click="selectAllSelectedSessions" class="select-all-button"><span></span> Select All</a>
                    </div>
                  </div>
                </div>
              </div>              
            </div>
            <div class="map-button-area mt-5">
              <vs-button color="primary" type="flat" class="mr-3">Reset</vs-button>
              <vs-button color="rgb(76, 139, 246)" type="filled" @click="mapSessionAttendee">Map</vs-button>
            </div>
          </vs-popup>
        </div>

      </div>
      <div class="vx-row">
        <!-- ITEMS PER PAGE -->
        <div class="vx-col md:w-1/2 w-full">          
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="export-import-buttons-right">            
            <!--<vs-button type="gradient" class="mr-3">Map Users</vs-button>
            <vs-button type="border" text-color="#7367F0" class="mr-3">Delete</vs-button>
            <vs-button type="border" text-color="#7367F0" class="mr-3">Export</vs-button>
            <vs-button type="border" text-color="#7367F0">Import</vs-button>-->
          </div>
        </div>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="groupData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationGroupSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Datepicker from 'vuejs-datepicker';
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from 'moment-timezone'

// Store Module
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleTrackManagement from "@/store/track-management/moduleTrackManagement.js";
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import ls from "@/common/localStorage";

// Cell Renderer
import CellRendererChangeStatusGroup from "./cell-renderer/CellRendererChangeStatusGroup.vue";
import CellRendererEditGroup from "./cell-renderer/CellRendererEditGroup.vue";

let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate")
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate")
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ")

export default {
  components: {
    AgGridVue,
    vSelect,
    Datepicker,
    // Cell Renderer
    CellRendererEditGroup,
    CellRendererChangeStatusGroup,
  },
  data() {
    return {
      switch5: false,
      StartDate: null,
      popupActive: false,
      selectedTab:2,
      Attendee: null,
      showInside: false,
      showInside2: false,
      searchQuery: "",
      sessionList: [],
      attendeeList: [],
      SelectedSessions: [],
      SelectedGroups: [],
      SelectedSessionsOuter: [],
      SelectedGroupsOuter: [],
      SelectAllSessions: null,
      SelectAllGroups: null,
      sessionName: null,
      groupName: null,
      SessionEdit: false,
      session_search_list: [],
      group_search_list: [],
      unmap_groups: [],
      trackList: [],
      Track: null,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'GroupId',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Name",
          field: "GroupName",
          filter: true,
          width: 300,
        }, 
         {
          headerName: "Attendees",
          field: "Attendees",
          cellRenderer: (data) => {
            return data.value ? data.value.length : 0
          },
          filter: true,
        },
        {
          headerName: "Agenda",
          field: "Sessions",
          cellRenderer: (data) => {
            return data.value ? data.value.length : 0
          },
          filter: true,
        },  
        { 
          headerName: "Status",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererChangeStatusGroup",
          cellRendererParams: (params) => {
            let Group = {
              GroupId: params.data.GroupId,                
              GroupName: params.data.GroupName
            }
            return { Group: Group };
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 200,
          cellRendererFramework: "CellRendererEditGroup",
          cellRendererParams: (params) => {
            return { group: params.data };
          },
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererEditGroup,
        CellRendererChangeStatusGroup,
      }
    };
  },
  watch: {
    Track(val){
      this.searchSession()
    },
    StartDate(val){
      this.searchSession()
    }
  },
  computed: {    
    groupData() {
      this.group_search_list = this.group_list = this.$store.state.agendaManagement.groups;
      return this.$store.state.agendaManagement.groups;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  events: {
    closeEvent: function () {
      console.log('close event called')
      this.hide()
    }
  },
  methods: {
    searchGroup() {
      let groupName = this.groupName.trim().toLowerCase();
      if (groupName) {
        this.group_search_list = this.group_list.filter((row) => {
          if (
            String(row.GroupName).toLowerCase().includes(groupName)           
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        this.group_search_list = this.group_list;
      }
    },
    removeSession(session){
      let id = session.SessionId
      let index = this.SelectedSessions
        .map((x) => {
          return x.SessionId;
        })
        .indexOf(id);
      this.SelectedSessions.splice(index, 1);
    },
    searchSession() {
      this.session_search_list = this.sessionList; 
      if(this.StartDate){
        let StartDate = this.StartDate
        this.session_search_list = this.session_search_list.filter((row) => {
          if (
            new Date(row.StartDate.seconds * 1000) >= new Date(StartDate)
          ) {
            return true;
          } else {
            return false;
          }
        });
      }      
      if(this.Track){
        let Track = this.Track
        this.session_search_list = this.session_search_list.filter((row) => {
          if (
            row.Track.TrackName.includes(Track.TrackName)            
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
      if (this.sessionName) {
        let sessionName = this.sessionName.trim().toLowerCase();
        this.session_search_list = this.session_search_list.filter((row) => {
          if (
            String(row.Name).toLowerCase().includes(sessionName)            
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    },
    selectAllGroups: function() {
        this.SelectedGroups = [];
        if (this.SelectAllGroups) {
          this.group_search_list.forEach(row => {
              this.SelectedGroups.push(row);
          })
        }        
    },
    selectAllSessions: function() {
        this.SelectedSessions = [];
        if (this.SelectAllSessions) {
          this.session_search_list.forEach(row => {
              this.SelectedSessions.push(row);
          })
        }        
    },
    selectAllSelectedSessions: function() {
      this.SelectedSessionsOuter = []
      this.SelectedSessions.forEach(row => {
          this.SelectedSessionsOuter.push(row);
      })
    },
    selectAllSelectedGroups: function() {
      this.SelectedGroupsOuter = []
      this.SelectedGroups.forEach(row => {
          this.SelectedGroupsOuter.push(row);
      })
    },
    deleteAllSelectedSessions: function() {
        /*this.SelectedSessionsOuter.map(row => {
            let id = row.SessionId
            let index = this.SelectedSessions
              .map((x) => {
                return x.SessionId;
              })
              .indexOf(id);
            this.SelectedSessions.splice(index, 1);
        })

        this.SelectedSessionsOuter = []*/
        this.unmapSessionAttendee();
    },
    deleteAllSelectedGroups: function() {
        this.unmap_groups = this.SelectedGroupsOuter
        this.SelectedGroupsOuter.map(row => {
            let id = row.AttendeeId
            let index = this.SelectedGroups
              .map((x) => {
                return x.AttendeeId;
              })
              .indexOf(id);
            this.SelectedGroups.splice(index, 1);
        })
        this.SelectedGroupsOuter = []
    },
    show: function () {
      this.showInside = true 
      this.showInside2 = false 
    },
    show2: function () {
      this.showInside = false 
      this.showInside2 = true 
    },
    hide: function () { 
      console.log('hide')
      this.showInside = false
      this.SelectAllSessions = null
      this.showInside2 = false
      this.SelectAllGroups = null
    },
    getListData(tab){
      if(tab == 'User')
        this.$router.push("/event/usermapping/");
      else if(tab == 'Group')
        {}
      else
        this.$router.push("/event/sessionmapping/");
    },    
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    SetTimeByZoneinList: function(strDateTime)
    {  
        var date = moment.tz(strDateTime, Session_Event_TZ).format('MM/DD/YYYY HH:mm A');
        return date
    },
     SetTimeByZone : function(strDateTime, timeZone)
    {  
        var date = moment.tz(strDateTime, timeZone).format('MM/DD/YYYY HH:mm A');
        return date
    },
  GetTimeByZone : function(strDateTime, timeZone)
    {
      
      strDateTime = moment(strDateTime).format('YYYY-MM-DD HH:mm')
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);      
      return strtDate._d;      
    }, 
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    addMapping(){
      this.SessionEdit = false
      this.Track = null
      this.SelectedGroups = []
      this.SelectedSessions = []
      this.unmap_attendees = []
      this.popupActive = true
    },
    editMapping(group){
      this.unmap_groups = []
      this.SessionEdit = true;
      if(group)
      {
        this.SelectedGroups = [{
          GroupId: group.GroupId,          
          GroupName: group.GroupName
        }]
        this.$vs.loading();
        this.$store
          .dispatch("agendaManagement/fetchSessionsInGroup", group.GroupId)
          .then(res => {  
            this.SelectedSessions = res.map(row =>{ 
              return {
                SessionId: row.SessionId,
                StartDate: row.StartDate,
                EndDate: row.EndDate,
                Track: row.Track,
                Name: row.Name
              }
            })
            this.$vs.loading.close();
            this.popupActive = true
        })
            
          
      }

    },
    getSessions(){
      this.$store
          .dispatch("sessionManagement/fetchSessions")
          .then(res => {  
            this.session_search_list = this.sessionList = res.map(row => {
              return {
                SessionId: row.SessionId,
                StartDate: row.StartDate,
                EndDate: row.EndDate,
                Track: row.Track,
                Name: row.Name
              }
            })    

          })
    },
    
    getTracks(){
      this.$store
          .dispatch("trackManagement/fetchTracksDropdown")
          .then(res => {  
            this.trackList = res    

          })
    },
    unmapSessionAttendee(){
      let SelectedSessionsOuter = this.SelectedSessionsOuter
      let SelectedGroups = this.SelectedGroups
      //let unmap_groups = this.unmap_groups
      //if(SelectedSessions.length && SelectedGroups.length){
        let sessions = SelectedSessionsOuter.map(row=>{
          row.StartDate = new Date(row.StartDate.seconds * 1000).toUTCString();
          row.EndDate = new Date(row.EndDate.seconds * 1000).toUTCString();
          return row
        })
        this.$vs.loading();
        let store = this.$store
            this.$store.dispatch("agendaManagement/mapSessionAttendee", {
              sessions: sessions,
              attendees: [],
              unmap_attendees: [],
              mapgroups: [],
              unmapgroups: SelectedGroups
            }).then(res => {  
              if(res.status == 200)
              {
                this.$vs.notify({
                    color: "success",
                    position: "top-center",
                    title: "Mapping",
                    text: "Data Saved successfully.",
                  });


              }
              else
              {
                this.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  title: "Mapping",
                  text: "Data not Saved!",
                });
              } 
              this.unmap_groups = []
               this.popupActive = false           
              this.$vs.loading.close();
              location.reload();
            })
         
    },
    mapSessionAttendee(){
      let SelectedSessions = this.SelectedSessions
      let SelectedGroups = this.SelectedGroups
      let unmap_groups = this.unmap_groups
      //if(SelectedSessions.length && SelectedGroups.length){
        let sessions = SelectedSessions.map(row=>{
          /*row.StartDate = moment.tz(new Date(row.StartDate.seconds * 1000).toUTCString(), Session_Event_TZ).format('DD/MM/YYYY HH:mm A')
          row.EndDate = moment.tz(new Date(row.EndDate.seconds * 1000).toUTCString(), Session_Event_TZ).format('DD/MM/YYYY HH:mm A')*/
          row.StartDate = new Date(row.StartDate.seconds * 1000).toUTCString();
          row.EndDate = new Date(row.EndDate.seconds * 1000).toUTCString();
          return row
        })

        /*let mapGroupIds = SelectedGroups.map(row => {
          return row.GroupId
        })
        let unmapGroupIds = unmap_groups.map(row => {
          return row.GroupId
        })*/
        this.$vs.loading();
        let store = this.$store
        //this.$store.dispatch("agendaManagement/fetchAttendeesInGroupbyMultipleId",mapGroupIds).then(mappedAttendees =>{
          //this.$store.dispatch("agendaManagement/fetchAttendeesInGroupbyMultipleId",unmapGroupIds).then(unmappedAttendees =>{
            this.$store.dispatch("agendaManagement/mapSessionAttendee", {
              sessions: sessions,
              attendees: [],
              unmap_attendees: [],
              mapgroups: SelectedGroups,
              unmapgroups: unmap_groups
            }).then(res => {  
              if(res.status == 200)
              {
                this.$vs.notify({
                    color: "success",
                    position: "top-center",
                    title: "Mapping",
                    text: "Data Saved successfully.",
                  });


              }
              else
              {
                this.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  title: "Mapping",
                  text: "Data not Saved!",
                });
              } 
              this.unmap_groups = []
               this.popupActive = false           
              this.$vs.loading.close();
              location.reload();
              //this.$store.dispatch("agendaManagement/fetchGroups")
            })
         // })
        //})
      /*}
      else
      {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Mapping",
          text: "Session & Attendee should be selected!",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }*/
    }
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }

    this.$root.$on("openMappingPopUp", this.editMapping)
  },
  created() {
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule("attendeeManagement", moduleAttendeeManagement);
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleTrackManagement.isRegistered) {
      this.$store.registerModule("trackManagement", moduleTrackManagement);
      moduleTrackManagement.isRegistered = true;
    }
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    this.$store.dispatch("agendaManagement/fetchGroups")
    this.getSessions();
    this.getTracks();
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>